<template>
  <div id="device-user-days">
    <dx-data-grid
      class="data-grid dx-card content-block"
      :data-source="dataSourceConfig"
      :height="gridHeight"
      :remote-operations="remoteOperations"
      :syncLookupFilterValues="false"
      @content-ready="onContentReady"
      @context-menu-preparing="addMenuItems"
      @editor-preparing="onEditorPreparing"
      @initialized=initializedGrid
      ref="dataGrid"
    >
      <dx-paging :enabled="true"
        :page-size="rowCountHistory" :page-index="pageIndex"
      />
      <dx-pager
        :visible="true"
        :allowed-page-sizes="pageSize"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="false"
      />

      <dx-filter-row :visible="true" />
      <dx-header-filter :visible="true" />
      <dx-sorting mode="multiple" />
      <dx-state-storing
        :enabled="true"
        type="custom"
        :customLoad="stateLoad"
        :customSave="stateSave"
      />
      <dx-filter-panel :visible="showFilterPanel" />

      <dx-column
        data-field="periodFrom"
        :caption="$t('device.deviceHistory.periodFrom')"
        :allow-header-filtering="false"
        :width="160"
        data-type="datetime"
        format="dd.MM.yyyy HH:mm:ss"
        selected-filter-operation="between"
      />

      <dx-column
        data-field="periodTo"
        :caption="$t('device.deviceHistory.periodTo')"
        :allow-header-filtering="false"
        :width="160"
        data-type="datetime"
        format="dd.MM.yyyy HH:mm:ss"
        selected-filter-operation="between"
      />

      <dx-column
        data-field="ip"
        :caption="$t('device.deviceHistory.ip')"
        :allow-header-filtering="false"
        :width="140"
      />
    </dx-data-grid>

    <CustomColumnChooser
      :visible="visible"
      :columns="columns"
      :onApply="onApply"
      :onHiding="onHiding"
    />
  </div>
</template>

<script>
import baseView from "../base";

import DxDataGrid, {
  DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxStateStoring, DxFilterPanel, DxPager,
  DxSorting
} from "devextreme-vue/data-grid";

import CustomColumnChooser from "@/components/column-chooser/CustomColumnChooser.vue";

import { findDeviceHistory } from "@/services/api";
import { AclHandler } from "@/services/acl-handler";

import { DataDrid } from "@/mixins/dataDridMixin";

import {
  PAGE_HEADER_HEIGHT,
  PAGE_PADDING,
  PAGE_TOOLBARS_HEIGHT,
  PAGE_FOOTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  GRID_FILTER_ROW_HEIGHT,
  GRID_FILTER_PANEL_HEIGHT,
  GRID_PAGER_HEIGHT
} from '@/shared/consts/layout';

export default {
  name: "DeviceHistory",
  props: ["id"],
  extends: baseView,
  mixins: [DataDrid],
  components: {
    DxDataGrid, DxColumn, DxFilterRow, DxHeaderFilter, DxPaging, DxStateStoring,
    DxFilterPanel, CustomColumnChooser, DxPager, DxSorting
  },
  data() {
    return {
      isCloudMode: this.$store.getters.isCloudMode,
      remoteOperations: { groupPaging: true },
      dataSourceConfig: { store: this.createDataSource(findDeviceHistory) },
      pageIndex: 0
    };
  },
  computed: {
    appUser() {
      return this.$store.getters.user;
    },
    aclUser() {
      return new AclHandler(this.appUser, this.isCloudMode);
    },
    showFilterPanel() {
      return this.aclUser.hasGrantForOperation('BTN_CLEAR_FILTER', 'EXECUTE') || false;
    },
    sumGap() {
      return PAGE_HEADER_HEIGHT + PAGE_PADDING + PAGE_TOOLBARS_HEIGHT + PAGE_FOOTER_HEIGHT;
    },
    gridHeight() {
      const appHeightSize = this.$store.getters.appContainerSize.height;
      const headerDeviceHeight = 80;
      const tabListHeight = 37;

      return (appHeightSize || 800) -
        this.sumGap -
        headerDeviceHeight -
        tabListHeight;
    },
    gridBodyHeight() {
      return this.gridHeight -
        GRID_HEADER_HEIGHT -
        (this.showFilterPanel ? GRID_FILTER_PANEL_HEIGHT : 0) -
        GRID_FILTER_ROW_HEIGHT -
        GRID_PAGER_HEIGHT;
    },
    rowCountHistory() {
      return this.countRows(this.gridBodyHeight);
    },
  },
  methods: {
    onEditorPreparing(e) {
      this.applyFilterRowTimeout(e);
    },
    onContentReady(e) {
      this.addFitToPageHeightButton(e);
    },
    beforeQueryData(query) {
      if (query.filterJson) {
        query.filterJson = [query.filterJson, "and", ["device.id", "=", parseInt(this.id, 10)]];
      } else {
        query.filterJson = ["device.id", "=", parseInt(this.id, 10)];
      }
      // eslint-disable-next-line no-console
      // console.debug("DeviceUserDays::beforeQueryData", query);
    },
  },
  created() {
    this.gridStateKey = 'gridDeviceHistory';
  },
  beforeDestroy() {
    const state = this.dataGrid.state();
    this.stateSave(state);
  },
  watch: {
    id() {
      this.gridInstance.refresh();
    }
  }
};
</script>

<style lang="scss">
</style>
